module.exports = __webpack_public_path__ + "static/hr-group.resized-c6f098c77ddb687189aa694ee00186be.jpg";